import { render, staticRenderFns } from "./search-history.vue?vue&type=template&id=5a3b371a&scoped=true&"
import script from "./search-history.vue?vue&type=script&lang=js&"
export * from "./search-history.vue?vue&type=script&lang=js&"
import style0 from "./search-history.vue?vue&type=style&index=0&id=5a3b371a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3b371a",
  null
  
)

export default component.exports